import { lazy, type LazyExoticComponent } from 'react';

import type { ActionKeys } from '@atlassian/conversation-assistant-message-actions-api/constants';
import type { ActionRendererFor } from '@atlassian/conversation-assistant-message-actions-api/types';

export const JiraAdminAgentRendererAsync: LazyExoticComponent<
	(props: ActionRendererFor<typeof ActionKeys.JiraAdminAgent>) => React.JSX.Element
> = lazy(() =>
	import(
		/* webpackChunkName: "@atlassian/ai-mate-jira-admin-agent-renderer" */ './JiraAdminAgentRenderer'
	).then((m) => ({ default: m.JiraAdminAgentRenderer })),
);
